import {
  CACHE_TAG_DISPOSAL_TICKET_VERSION_LIST,
  CACHE_TAG_ROUTES_STOPS,
  CACHE_TAG_WORK_ORDER_DISPOSAL_TICKET,
  CACHE_TAG_WORK_ORDER_LIST,
  CACHE_TAG_WORK_ORDER_LIST_SUMMARY,
} from 'api/cacheTagTypes'
import { withIdTag } from 'utils/cache'

import api from '../index'

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    deleteWorkOrdersDisposalTicket: builder.mutation({
      query: ({ workOrderId, disposalTicketId }) => ({
        url: `/api/v1/core/work-orders/${workOrderId}/disposal-tickets/${disposalTicketId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, arg) => [
        CACHE_TAG_WORK_ORDER_LIST,
        CACHE_TAG_WORK_ORDER_LIST_SUMMARY,
        CACHE_TAG_ROUTES_STOPS,
        CACHE_TAG_WORK_ORDER_DISPOSAL_TICKET,
        ...withIdTag(CACHE_TAG_DISPOSAL_TICKET_VERSION_LIST, arg.workOrderId),
      ],
    }),
  }),
})

export const { useDeleteWorkOrdersDisposalTicketMutation } = extendedApi
